import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";

const { carbon } = colorsPalettes;

export const RedirectToUrl = styled.a`
    display: none;
    margin-left: 6px;

    .SWReactIcons {
        display: flex;
    }

    .SWReactIcons,
    svg {
        width: 12px;
        height: 12px;

        path {
            fill: ${carbon[500]};
        }
    }
`;

export const RecomendationListItemWrapper = styled.div`
    border-bottom: 1px solid ${carbon[50]};
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0px 8px 0px 16px;
    box-sizing: border-box;
    height: 44px;
    align-items: center;

    &:hover {
        background-color: ${carbon[25]};

        ${RedirectToUrl} {
            display: block;
        }
    }
`;

export const DomainItemContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const Domain = styled.span`
    ${setFontVariant("input2", carbon[500])};
    line-height: inherit;
    text-indent: 8px;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 340px;
    display: flex;
`;
